// componente che verifica se l'utente è loggato nell'applicativo; in caso contrario reindirizza verso la pagina
// di login 

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../../service/authentication.service';
// classe User utilizzata per definire il contenuto degli oggetti di tipo utente scambiati col back-end
export class User {
    username: string;
    telephone: string;
    email: string;
    bodyid: string;
    firstname: string;
    lastname: string;
    profile: string;
    token: string;
}

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            return true;
        }
        this.router.navigate([''], { queryParams: { returnUrl: state.url } });
        return false;
    }
}